export default __webpack_public_path__ + "static/avatar-kortical-team1-24cc07a768c81c36ec2fb20e466dcbec.webp";